import { render } from "./ContextChip.vue?vue&type=template&id=764cb5fd&ts=true"
import script from "./ContextChip.vue?vue&type=script&lang=ts"
export * from "./ContextChip.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__